import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Stack, Chip, Divider, Box } from '@mui/material';

const formatDateTime = (value) => {
  if (!value) return '-';
  const date = typeof value === 'string' ? new Date(value) : value;
  if (Number.isNaN(date.getTime())) return '-';
  return date.toLocaleString('tr-TR');
};

const resolveContentType = (contentType) => {
  if (typeof contentType === 'string') {
    return contentType.toLowerCase() === 'plaintext' ? 'Düz Metin' : 'HTML';
  }
  return Number(contentType) === 1 ? 'Düz Metin' : 'HTML';
};

const EmailTemplatePreviewDialog = ({ open, onClose, template }) => {
  if (!template) return null;
  const placeholders = template.placeholders
    ? template.placeholders.split(',').map((item) => item.trim()).filter(Boolean)
    : [];

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>{template.name}</DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2}>
          <Stack direction="row" spacing={1} alignItems="center">
            <Chip label={template.isActive ? 'Aktif' : 'Pasif'} color={template.isActive ? 'success' : 'default'} size="small" />
            {template.isSystemTemplate && <Chip label="Sistem Şablonu" size="small" color="primary" variant="outlined" />}
            <Chip label={resolveContentType(template.contentType)} size="small" variant="outlined" />
          </Stack>
          <Stack spacing={0.5}>
            <Typography variant="subtitle2" color="text.secondary">
              Konu
            </Typography>
            <Typography>{template.subject}</Typography>
          </Stack>

          {template.description && (
            <Stack spacing={0.5}>
              <Typography variant="subtitle2" color="text.secondary">
                Açıklama
              </Typography>
              <Typography>{template.description}</Typography>
            </Stack>
          )}

          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={4}>
            <Stack spacing={0.5}>
              <Typography variant="subtitle2" color="text.secondary">
                Oluşturulma
              </Typography>
              <Typography>{formatDateTime(template.createdAt)}</Typography>
            </Stack>
            <Stack spacing={0.5}>
              <Typography variant="subtitle2" color="text.secondary">
                Güncelleme
              </Typography>
              <Typography>{template.updatedAt ? formatDateTime(template.updatedAt) : '-'}</Typography>
            </Stack>
          </Stack>

          {placeholders.length > 0 && (
            <Stack spacing={0.5}>
              <Typography variant="subtitle2" color="text.secondary">
                Yer Tutucular
              </Typography>
              <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                {placeholders.map((ph) => (
                  <Chip key={ph} label={ph} size="small" variant="outlined" />
                ))}
              </Stack>
            </Stack>
          )}

          <Divider />

          <Stack spacing={0.5}>
            <Typography variant="subtitle2" color="text.secondary">
              İçerik Önizleme
            </Typography>
            {Number(template.contentType) === 1 || template.contentType === 'PlainText' ? (
              <Box
                component="pre"
                sx={{
                  bgcolor: 'background.default',
                  borderRadius: 1,
                  p: 2,
                  maxHeight: 400,
                  overflow: 'auto',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {template.body}
              </Box>
            ) : (
              <Box
                sx={{
                  border: '1px solid',
                  borderColor: 'divider',
                  borderRadius: 1,
                  p: 2,
                  maxHeight: 400,
                  overflow: 'auto',
                  backgroundColor: 'background.paper',
                }}
                dangerouslySetInnerHTML={{ __html: template.body }}
              />
            )}
          </Stack>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Kapat</Button>
      </DialogActions>
    </Dialog>
  );
};

export default EmailTemplatePreviewDialog;


